import { render, staticRenderFns } from "./WavePickComplete.vue?vue&type=template&id=63563f7f&"
import script from "./WavePickComplete.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WavePickComplete.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports